<template>
  <div class="product_inf" style="">
    <card title="“毒豆芽”真正的危害">
      <div
        class="product_inf_content"
        style="padding:0rem 2rem 0.6rem 1.8rem;color: #faefac; "
        v-html=" OriginIntroduction.msgContent">


        <!--        <span class="inlineblock width100 redfont" style="font-size:20px;">-->
        <!--          &nbsp;&nbsp;&nbsp;&nbsp;“毒豆芽”真正的危害-->
        <!--        </span>-->
        <!--        <span class="inlineblock width100 yellowfont minfont">-->
        <!--          &emsp;&emsp;<span class="redfont">1.种植标准缺失：</span>豆芽行业介于农产品与食品之间.原本按照食品工厂建设标准来做豆芽工厂的基础理设是非常成熟和合理的方案。但因为大量使用地下水，且地下水资源储量不确定性，面对着随时搬厂的可能性。就使的行业在工厂建设上大规模投入或标准化投入的风险变得很高。逐步形成了现在行业呈现出的小、散、乱的局面。-->
        <!--        </span>-->
        <!--        <span class="inlineblock width100 yellowfont minfont">-->
        <!--            &emsp;&emsp;<span class="redfont">2.水资源浪费及污染: </span>每吨豆芽种植生产预计用水40吨左右，目前全行业种植都采用地下水为种植用水，按照全年豆芽测算预估需求量480万吨/年，预计消耗地下水资源1.92亿m%。按目前市政供水平均价格.国家年损失10亿元以上。-->
        <!--大体量的采水需要在承压层摄取，但承压层水资源的形成大体时间在1000-1400年左右。自然循环基本无法满足豆芽行业摄水量。致使承压水层亏空.产生环境、地质问题。-->
        <!--豆芽行业大量开采地下水未经过审批，排放也无法监管成为了衍生的新问题。-->
        <!--国家“十四五”地下水专项调查结论-一-地下水超采严重整治迫在眉睫。-->
        <!--        </span>-->
        <!--        <span class="inlineblock width100 yellowfont minfont">-->
        <!--            &emsp;&emsp;<span class="redfont">3.添加剂滥用: </span>-->
        <!--因为前两个原因，致使行业标准无法执行，生产环境恶劣，无法满足无添加豆芽的种植条件，在此情形下大量使用添加剂成为唯一出路。-->
        <!--且添加剂的种类及成分随着时间的发展已经越来越丰富，但是国标及行标一直未有更新，造成了监管的难度，导致目前市场上添加剂豆芽横行。-->
        <!--        </span>-->
      </div><!--滑动门背景增加代码-->
      <div
        class="top-item top-item-left"
        style="width: 100%"
        v-for="(item,index) in OriginIntroduction.organization"
        :key="index">
        <img :src="item" alt="" style="width: 89%;margin: 0 5%">
      </div>
    </card>
  </div>
</template>

<script>
import card from '@views/general/modules/Card.vue'

export default {
  name: 'SciencePopularization',
  components: { card },
  props: {
    OriginIntroduction: {
      type: Object,
      default: () => ({
        isShow: true,
        msgContent: '',
        organization: ''
      })
    }
  },
  data() {
    return {
      // logo: require('../../../assets/card/logo.png'),
      // factory: require('../../../assets/productComparison.png')
    }
  },
  watch: {
    OriginIntroduction() {
      console.log('video->' + this.OriginIntroduction.video)
      this.getVideoBase64(this.OriginIntroduction.video)
        .then((dataUrl) => {
          console.log('url->' + dataUrl)
          this.videoImg = dataUrl
        })
        .catch((error) => {
          console.error(error) // 打印错误信息
        })
    }
  },
  methods: {
    getVideoBase64(url) {
      return new Promise(resolve => {
        let dataURL = ''
        const video = document.createElement('video')
        video.setAttribute('crossOrigin', 'anonymous')// 处理跨域
        video.setAttribute('src', url)
        video.setAttribute('width', '400')
        video.setAttribute('height', '240')
        video.setAttribute('preload', 'auto') // 防止截取图片黑屏的关键属性
        video.setAttribute('autoplay', 'autoplay')
        video.addEventListener('loadeddata', () => {
          const canvas = document.createElement('canvas')
          const width = video.videoWidth // canvas的尺寸和视频一样
          const height = video.videoHeight
          canvas.width = width
          canvas.height = height
          canvas.getContext('2d').drawImage(video, 0, 0, width, height) // 绘制canvas
          const imageData = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height) // 绘制canvas
          const arr = imageData.data
          dataURL = canvas.toDataURL('image/png') // 转换为base64
          const brr = []
          for (let a = 0; a < arr.length; a++) {
            const arrItem = arr[a]
            if (arrItem > 0 && arrItem < 200) {
              brr.push(arrItem)
            }
          }
          if (!brr.length) {
            // 截取的图片无效（黑屏、白屏、透明），这里可以返回系统默认图片
          }
          resolve(dataURL)
        })
      })
    },
    getVideoFirstFrame(videoUrl) {
      // debugger
      // 创建video元素
      const video = document.createElement('video')
      video.src = videoUrl
      video.setAttribute('crossOrigin', 'Anonymous') // 处理跨域
      video.setAttribute('preload', 'auto') // auto|metadata|none
      // 等待视频加载完成
      return new Promise((resolve, reject) => {
        video.addEventListener('loadedmetadata', () => {
          // 创建canvas元素
          const canvas = document.createElement('canvas')
          canvas.width = video.videoWidth
          canvas.height = video.videoHeight

          // 将视频第一帧绘制到canvas上
          const ctx = canvas.getContext('2d')

          ctx.drawImage(video, 0, 0, canvas.width, canvas.height)

          // 将canvas图像转换为base64格式的数据URI
          const dataUrl = canvas.toDataURL()

          // 返回base64格式的数据URI
          resolve(dataUrl)
        })

        // 如果视频加载出错，则返回错误信息
        video.addEventListener('error', () => {
          reject(`Failed to load video: ${videoUrl}`)
        })
      })
    }
  }
}
</script>
